import React from 'react';
import { Box, Img, Text } from '../element';

const IconOptionItem = ({ option = '', iconClass, iconSrc, iconAlt = 'Model Icon' }) => (
  <Box className="padding1" align="start" direction="row" data-test-id={`icon-${option}`}>
    <Img className={iconClass} src={iconSrc} alt={iconAlt} />
    <Box direction="row" margin={{ left: 'xsmall' }}>
      <Text className="fontSize18">{option}</Text>
    </Box>
  </Box>
);

export default IconOptionItem;
